/**
 * 對講機類型 Enum
 * @enum {number}
 */
export const SentryType = Object.freeze({
  VoipPhone: 1, // 社區硬體電話
  TabletPhone: 2, // 戶別軟體電話
  CommunityPhone: 3, // 社區軟體電話
  TabletVoipPhone: 4, // 戶別硬體電話
  EntryPoint: 5 // 社區軟體門口
})
